{
  "it": {
    "chart": {
      "type": {
        "bar": "Grafico a barre",
        "bubble": "Grafico a bolle",
        "doughnut": "Grafico a ciambella",
        "horizontalBar": "Grafico a barre orizzontali",
        "line": "Grafico a linee",
        "multiAxis": "Grafico multi-asse",
        "pie": "Grafico a torta",
        "polarArea": "Grafico ad area polare",
        "radar": "Grafico radar",
        "stackedBar": "Grafico a barre impilate"
      }
    }
  }
}
